import { useTranslation } from 'react-i18next'

import { Trans } from '@/components/Trans'
import { cn } from '@/utils/style'

interface UpdateToggleProps {
  value: boolean
  onChange: (value: boolean) => void
  className?: string
  disabled?: boolean
  type: 'autoRenewal' | 'expirationBehavior'
}

export function UpdateToggle({
  value,
  onChange,
  className,
  disabled = false,
  type,
}: UpdateToggleProps) {
  const { t } = useTranslation()
  const isAutoRenewal = type === 'autoRenewal'

  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      aria-label={t(
        isAutoRenewal
          ? 'instance.detail.billing.autoRenewal'
          : 'instance.detail.billing.expirationBehavior',
      )}
      disabled={disabled}
      onClick={() => onChange(!value)}
      className={cn(
        'relative inline-flex h-6 items-center justify-center rounded-full px-2 py-0.5 text-[10px] font-semibold transition-colors',
        isAutoRenewal ? 'w-[70px]' : 'w-[150px]',
        value ? 'bg-[#246BFF] text-white' : 'bg-gray-300 text-gray-700',
        disabled && 'cursor-not-allowed opacity-60',
        className,
      )}
    >
      <span className="z-10 truncate text-xs">
        {isAutoRenewal ? (
          value ? (
            <Trans i18nKey="common.on">ON</Trans>
          ) : (
            <Trans i18nKey="common.off">OFF</Trans>
          )
        ) : value ? (
          <Trans i18nKey="instance.detail.billing.switchToPayAsYouGo">Pay-as-you-go</Trans>
        ) : (
          <Trans i18nKey="instance.detail.billing.releaseInstance">Release Instance</Trans>
        )}
      </span>

      <span
        aria-hidden
        className={cn(
          'absolute top-1 h-4 w-4 rounded-full bg-white shadow transition-all duration-200',
          value ? 'right-1' : 'left-1',
        )}
      />
    </button>
  )
}
